/* global bocAmchart */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValetCategories = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValetCategories(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 * Produces and returns an array of data based on the valet data for the data with categories,
 * rather than time data. function detects if data contains dimensions and chooses different preprocessing.
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValetCategories = function (data, dataLoader, chart) {
    var output,
        revisedText,
        categoryTerm,
        seriesTerm,
        seriesDetails,
        series,
        categorySet,
        terms,
        category,
        seriesSet;

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running postProcessValetCategories, inputs:",
            data,
            "Graphs: ",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    output = [];
    revisedText = bocAmchart.getRevisedText();

    // Try to detect dimensions first
    var dimensions = [];
    var dimension = false;

    for (series in data.seriesDetail) {
        if (data.seriesDetail.hasOwnProperty(series)) {
            seriesDetails = data.seriesDetail[series];
            if (seriesDetails.hasOwnProperty("dimension") && seriesDetails.dimension.hasOwnProperty("key")) {
                if (dimensions.indexOf(seriesDetails.dimension.key) === -1) {
                    dimensions.push(seriesDetails.dimension.key);
                }
            }
        }
    }

    if (dimensions.length > 0) {
        dimension = dimensions[0];
        if (dimensions.length > 1) {
            // eslint-disable-next-line no-console
            console.warn("Data error, more than one dimension found in one data set.");
        }
    }

    if (dimension === 'd') {
        dimension = false;
    }

    // Setting "named array" to avoid multiple loops through data
    categorySet = [];
    seriesSet = [];

    if (!dimension) {
        categoryTerm = 'category';

        if (chart.bocSettings.args.hasOwnProperty('categoryterm')) {
            categoryTerm = chart.bocSettings.args.categoryterm;
        }
        seriesTerm = 'series';
        if (chart.bocSettings.args.hasOwnProperty('seriesterm')) {
            seriesTerm = chart.bocSettings.args.seriesterm;
        }

        // Fill the terms data from series names before it is pushed as a feature in webmart and valet
        data = bocAmchart.termsPolyfill(data, categoryTerm, seriesTerm, chart.bocSettings);

        if (chart.bocSettings.args.hasOwnProperty('transpose') && chart.bocSettings.args.transpose === "true") {
            var temp = categoryTerm;
            categoryTerm = seriesTerm;
            seriesTerm = temp;
            if (bocAmchart.debug(chart)) {
                // eslint-disable-next-line no-console
                console.log(
                    chart.bocSettings.id,
                    "Transposing the data"
                );
            }
        }
    }

    // Loop through data attributes, and create graphs based on them, store series to skip
    chart.graphs = [];
    var reservedSeries = [];
    var label;
    for (var index = 0; index < 10; index++) {
        if (chart.bocSettings.args.hasOwnProperty('series' + index + 'openfield')
            && chart.bocSettings.args.hasOwnProperty('series' + index + 'closefield')
        ) {
            var highSeries, lowSeries;
            var openSeries = chart.bocSettings.args['series' + index + 'openfield'];
            var closeSeries = chart.bocSettings.args['series' + index + 'closefield'];
            reservedSeries.push(openSeries, closeSeries);
            if (chart.bocSettings.args.hasOwnProperty('series' + index + 'highfield')
                && chart.bocSettings.args.hasOwnProperty('series' + index + 'lowfield')
            ) {
                highSeries = chart.bocSettings.args['series' + index + 'highfield'];
                lowSeries = chart.bocSettings.args['series' + index + 'lowfield'];
                reservedSeries.push(highSeries, lowSeries);
            }

            label = openSeries;
            if (data.seriesDetail.hasOwnProperty(openSeries)) {
                label = data.seriesDetail[openSeries].label;
            }
            if (bocAmchart.debug(chart)) {
                // eslint-disable-next-line no-console
                console.log(
                    chart.bocSettings.id,
                    "Creating candlestick graph:",
                    "Series: ",
                    [openSeries, closeSeries, highSeries, lowSeries],
                    "Index:",
                    index
                );
            }
            bocAmchart.addGraph(
                chart,
                [openSeries, closeSeries, highSeries, lowSeries],
                label,
                'candlestick',
                index
            );
        }
        if (chart.bocSettings.args.hasOwnProperty('series' + index + 'valuefield')) {
            var valueSeries = chart.bocSettings.args['series' + index + 'valuefield'];
            reservedSeries.push(valueSeries);
            label = valueSeries;
            if (data.seriesDetail.hasOwnProperty(valueSeries)) {
                label = data.seriesDetail[valueSeries].label;
            }
            if (bocAmchart.debug(chart)) {
                // eslint-disable-next-line no-console
                console.log(
                    chart.bocSettings.id,
                    "Creating graph based on value defined in attributes:",
                    "Series: ",
                    valueSeries,
                    "Index:",
                    index
                );
            }
            bocAmchart.addGraph(chart, valueSeries, label, null, index);
        }
    }

    data.observations.forEach(function (obs) {

        if (dimension && obs.hasOwnProperty(dimension)) {

            // Set the category values based on dimension, make sure the value is string
            var category = obs[dimension];
            if (!isNaN(category)) {
                category += " ";
            }

            // Looping through series, and find an observation for each of them
            for (series in data.seriesDetail) {
                if (data.seriesDetail.hasOwnProperty(series)) {
                    if (obs.hasOwnProperty(series)) {
                        // Initialize the container for values of series for specific category
                        if (!categorySet.hasOwnProperty(category)) {
                            categorySet[category] = {};
                        }

                        // This value point belongs to series that has chosen dimension
                        if (seriesSet.indexOf(series) === -1) {
                            seriesSet.push(series);
                        }

                        categorySet[category][series] = obs[series].v;
                        if (obs[series].hasOwnProperty('r') && obs[series].r === 1) {
                            categorySet[category][series + '_R'] = revisedText;
                        }
                    }
                }
            }

        } else {

            // Looping through series, and find an observation for each of them
            for (series in data.seriesDetail) {

                // property is either date or series name, ignoring the date field for now
                if (data.seriesDetail.hasOwnProperty(series) && obs.hasOwnProperty(series)) {
                    seriesDetails = data.seriesDetail[series];
                    if (seriesDetails.hasOwnProperty('terms')) {
                        terms = seriesDetails.terms;
                        if (terms.hasOwnProperty(categoryTerm) && terms.hasOwnProperty(seriesTerm)) {

                            // This value point belongs to series that has category term defined
                            if (!categorySet.hasOwnProperty(terms[categoryTerm])) {
                                categorySet[terms[categoryTerm]] = {};
                            }

                            // This value point belongs to series that has category term defined
                            if (seriesSet.indexOf(terms[seriesTerm]) === -1) {
                                seriesSet.push(terms[seriesTerm]);
                            }

                            categorySet[terms[categoryTerm]][terms[seriesTerm]] = obs[series].v;
                            if (obs.hasOwnProperty('d')) {
                                categorySet[terms[categoryTerm]][terms[seriesTerm] + '_updated'] = obs.d;
                            }
                            if (obs[series].hasOwnProperty('r') && obs[series].r === 1) {
                                categorySet[terms[categoryTerm]][terms[seriesTerm] + '_R'] = revisedText;
                            }
                            if (terms.hasOwnProperty('term2')) {
                                categorySet[terms[categoryTerm]][terms[seriesTerm] + '_term2'] = terms['term2'];
                            }
                            if (terms.hasOwnProperty('term3')) {
                                categorySet[terms[categoryTerm]][terms[seriesTerm] + '_term3'] = terms['term3'];
                            }
                        }
                    }
                }
            }
        }
    });

    for (category in categorySet) {
        categorySet[category]['category'] = category;
        output.push(categorySet[category]);
    }

    // Add the column graph for each series term found
    seriesSet.forEach(function (term) {
        if (reservedSeries.indexOf(term) === -1) {
            if (dimension) {
                bocAmchart.addGraph(chart, term, data.seriesDetail[term].label, 'column');
            } else {
                bocAmchart.addGraph(chart, term, term, 'column');
            }
        }
    });

    bocAmchart.getChartTitlesFromGroup(data, chart);

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data after postProcessValetCategories:",
            output,
            "Graphs:",
            bocAmchart.debugClone(chart.graphs)
        );
    }

    return output;
};
